module.exports = __webpack_public_path__ + "img/oro2.cc3ed44b.png";